import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import Button from '../Form/Button';

import './ButtonContainer.scss';

const ButtonContainer = ({ buttons = [], showBack = false, onBack }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="button-container mb-4 d-flex justify-content-between align-items-center">
      <div className="back-button">
        {showBack ? (
          <button
            className="btn btn-lg btn-light"
            style={{fontSize: '16px'}}
            onClick={handleBack}
          >
            <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
            Back
          </button>
        ) : (
          <div style={{ width: '120px' }} /> // espace réservé pour alignement
        )}
      </div>

      <div className="button-wrapper d-flex">
        {buttons.map((button, index) => (
          <button
            key={index}
            className={`btn btn-lg ms-4 fw-bold ${button.className || ''}`}
            onClick={button.onClick}
            form={button.form}
            disabled={button.isLoading}
            style={button.style ?? {fontSize: '17px', padding: '11px 25px 11px 25px'}}
          >
            {button.isLoading ? (
              <>
                <span className="spinner-border spinner-border-sm me-3" />
                {button.loadingMessage || 'Loading...'}
              </>
            ) : (
              <>
                {button.icon && (
                  <FontAwesomeIcon icon={button.icon} className="me-3" />
                )}
                {button.label}
              </>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ButtonContainer;
